var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"i-btn",on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('Icon',{staticClass:"m-auto",attrs:{"name":_vm.icon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }